import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {setFulfillmentItemQuantity} from 'app/features/orders/redux/fulfillment/orderSlices'
import ProductImage from 'app/components/products/ProductImage'
import clsx from 'clsx'

type Props = {
  item: {
    id: string
    fulfillmentQuantity: number
    variant: any
    quantity: number
    fulfillableQuantity: number
    price: number
  }
  disabled: boolean
}

const ShippingLineItem: FC<Props> = ({item, disabled}) => {
  const dispatch = useDispatch()

  const handleChange = (e: any) => {
    let {value: quantity} = e.target
    if (quantity <= item.fulfillableQuantity) {
      dispatch(setFulfillmentItemQuantity({id: item.id, quantity}))
    }
  }

  const {
    variant: {name, weight, product},
  } = item

  return (
    <tr>
      <td>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-5'>
            <ProductImage product={product} />
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>{product.name}</span>
            <span className='text-muted fw-bold text-muted d-block fs-7'>{name}</span>
            <span className='text-dark fs-7 fw-bolder'></span>
          </div>
        </div>
      </td>
      <td className='text-end'>
        <div className='d-flex justify-content-end align-items-center'>
          {weight && (
            <div className='me-5'>
              <span className='text-muted fw-bold text-muted d-block fs-7'>
                {weight.value} {weight.units}
              </span>
            </div>
          )}

          <div className='position-relative w-lg-150px'>
            <input
              id='numChange'
              type='number'
              className={clsx('form-control', {
                'is-invalid': !disabled && item.fulfillableQuantity < item.fulfillmentQuantity,
              })}
              value={item.fulfillmentQuantity}
              onChange={handleChange}
              max={item.fulfillableQuantity}
              min={0}
              disabled={disabled}
            />

            <div className='position-absolute translate-middle-y top-50 end-0 me-10'>
              <span className='svg-icon svg-icon-2hx'>{`of ${item.fulfillableQuantity}`}</span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default ShippingLineItem
